import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Paper, Stack, TextField, Typography } from "@mui/material";
import { InfoOutlineRounded } from "@mui/icons-material";
import { isRichTextContentEmpty } from "../../../../utils/rich-text-empty";
import axios from "axios";
import { useSnackbar } from "../../../../components/snackbar";
import { AssessmentPreviewModel } from "./preview-model";
import { RenderRichText } from "../../components/rich-text/render-rich-text";

interface PreStartAssessmentProps {
    assessment: AssessmentPreviewModel;
    setStarted: React.Dispatch<React.SetStateAction<boolean>>;
}

export function PreStartAssessment({ assessment, setStarted }: PreStartAssessmentProps) {

    return (
        <Box
            sx={{
                backgroundColor: "#c6e1f5",
                minHeight: "100vh",
                display: "flex",
                padding: 1,
            }}
        >
            <Box
                sx={{
                    margin: 'auto',
                    width: '100%',
                    maxWidth: "700px",
                    backgroundColor: "#fff",
                    padding: 2,
                    borderRadius: 1,
                }}
            >

                 <Typography variant="h6" fontWeight={700} color="text.secondary">
                    {assessment.title}
                </Typography>

                <Box sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2 }} />


                {!isRichTextContentEmpty(assessment.instruction) && (
                    <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                            Instruction
                        </Typography>

                        <Box sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2 }} />
                        <RenderRichText jsonContent={assessment.instruction} />
                         <Box sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2 }} />
                    </Box>
                )}

            
                {/* Student Info & Start */}
                <Stack spacing={2}>
                    <TextField
                        value="Mac Donald"
                        fullWidth
                        disabled
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                    />
                    <TextField
                        value="ELMS/25/001"
                        fullWidth
                        disabled
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                    />
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => setStarted(true)}
                        sx={{ 
                            textTransform: "none", 
                            fontWeight: 600,
                            backgroundColor: "#059669",
                            '&:hover': {
                                backgroundColor: "#047857",
                            },
                        }}
                    >
                        Proceed
                    </Button>
                </Stack>
            </Box>
        </Box>
    )
}